const version = "0.0.1"; // 系统版本
const timeout = 200000; // 请求超时
const baseAPI = {
  development: "/api",
  dev: "/api",
  // test: `${process.env.BASE_HOST}`,
  // release: `${process.env.BASE_HOST}`,
  // production: `${process.env.BASE_HOST}`
  test: "https://test.yobomed.com/api",
  pre: "https://test.yobomed.com/api",
  prod: "https://stu.yobomed.com/api",
  release: "https://test.yobomed.com/api",
  production: "https://stu.yobomed.com/api",
};
const env = localStorage.getItem("env") || process.env.VUE_APP_ENV;
const baseURL = localStorage.getItem("newBaseAPI") || baseAPI[env];

// 系统参数配置
export default {
  version, // 系统版本
  timeout, // 请求超时
  baseAPI, // 所有环境接口对象
  env, // 当前环境
  baseURL, // 当前环境接口地址
  chainWebpack(config) {
    config.optimization.minimizer('terser').tap((args) => {
      args[0].terserOptions.compress.drop_console = true
      return args
    })
  },
  // 防止el-button重复点击
  directives: {
    preventReClick: {
      // 指令的定义
      inserted(el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 10000)
          }
        })
      }
    }
  },
};
